<template>
  <label
    class="grow flex items-center border border-gray-300 rounded-3xl h-[52px] focus-within:border-black pr-4"
  >
    <SearchIcon class="text-blue w-6 h-6 mx-4 fill-current" />
    <input
      class="grow font-sans text-base leading-8 outline-0"
      type="text"
      :placeholder="$t('Search')"
      v-bind="$attrs"
      :value="searchString"
      @input="handleInput"
    />
  </label>
</template>

<script setup lang="ts">
import SearchIcon from '~/assets/icons/search.svg?component'

const props = withDefaults(defineProps<{ modelValue: string }>(), {
  modelValue: '',
})

const searchString = computed<string>({
  get: () => {
    return props.modelValue
  },
  set: (newValue) => emit('update:modelValue', newValue),
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

function handleInput(event: Event) {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.value)
}
</script>
